/* MODE. free-shipping progress bar for the cart drawer (Horizon). Threshold in cents. */
(function () {
  var THRESHOLD = 9900; // $99.00 in cents. Change this to move the free-shipping threshold.
  var BAR_ID = 'mode-fs-bar';
  var busy = false;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function markup(total) {
    var remaining = Math.max(THRESHOLD - total, 0);
    var pct = THRESHOLD > 0 ? Math.min(100, Math.round((total / THRESHOLD) * 100)) : 100;
    var done = remaining <= 0;
    var msg = done
      ? "You've unlocked free shipping!"
      : "You're <strong>" + money(remaining) + "</strong> away from free shipping";
    return '<div id="' + BAR_ID + '" class="mode-fs' + (done ? ' mode-fs--done' : '') + '">' +
             '<div class="mode-fs__msg">' + msg + '</div>' +
             '<div class="mode-fs__track"><div class="mode-fs__fill" style="width:' + pct + '%"></div></div>' +
           '</div>';
  }

  function injectStyle() {
    if (document.getElementById('mode-fs-style')) return;
    var s = document.createElement('style');
    s.id = 'mode-fs-style';
    s.textContent =
      '.mode-fs{padding:14px 16px;font-family:inherit;font-weight:600;font-size:14px;line-height:1.3;}' +
      '.mode-fs__msg{margin-bottom:8px;color:#0A0A0A;}' +
      '.mode-fs__msg strong{color:#F24D00;}' +
      '.mode-fs__track{height:8px;border-radius:99px;background:#e6e6e6;overflow:hidden;}' +
      '.mode-fs__fill{height:100%;background:#F24D00;border-radius:99px;transition:width .4s ease;}' +
      '.mode-fs--done .mode-fs__msg{color:#1E7A34;}.mode-fs--done .mode-fs__msg strong{color:#1E7A34;}';
    document.head.appendChild(s);
  }

  function place(total) {
    injectStyle();
    var container = document.querySelector('.cart-drawer__content');
    if (!container) return;
    var existing = container.querySelector('#' + BAR_ID);
    if (existing) existing.outerHTML = markup(total);
    else container.insertAdjacentHTML('afterbegin', markup(total));
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { place(c.total_price); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Fire on Horizon cart events + common fallbacks
  ['CartAddEvent', 'CartUpdateEvent', 'cart:add', 'cart:update', 'cart:change', 'cart:refresh']
    .forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 60); }); });

  // Catch any AJAX to /cart/* (add, change, update) as a robust fallback
  var _fetch = window.fetch;
  window.fetch = function () {
    var p = _fetch.apply(this, arguments);
    try {
      var u = (arguments[0] && arguments[0].url) || arguments[0] || '';
      if (String(u).indexOf('/cart') > -1) p.then(function () { setTimeout(refresh, 150); });
    } catch (e) {}
    return p;
  };

  // Self-heal: if the drawer re-renders and drops the bar, put it back
  new MutationObserver(function () {
    var c = document.querySelector('.cart-drawer__content');
    if (c && !c.querySelector('#' + BAR_ID)) refresh();
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();

/* MODE. flavour swatch dots on variant buttons (Raspberry pink, Tropical yellow) */
(function () {
  var COLORS = { raspberry: '#D01F45', tropical: '#FFC400' };
  function addDot(label) {
    if (label.querySelector('.mode-swatch-dot')) return;
    var textEl = label.querySelector('.variant-option__button-label__text');
    var t = (textEl || label).textContent.toLowerCase();
    var c = null;
    for (var k in COLORS) { if (t.indexOf(k) > -1) { c = COLORS[k]; break; } }
    if (!c) return;
    var s = document.createElement('span');
    s.className = 'mode-swatch-dot';
    s.style.cssText = 'display:inline-block;width:14px;height:14px;border-radius:50%;margin-right:8px;vertical-align:middle;border:1px solid rgba(0,0,0,.15);flex:0 0 auto;background:' + c + ';';
    if (textEl) textEl.parentNode.insertBefore(s, textEl); else label.insertBefore(s, label.firstChild);
  }
  function run() {
    var labels = document.querySelectorAll('.variant-option--buttons .variant-option__button-label');
    for (var i = 0; i < labels.length; i++) addDot(labels[i]);
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
